import React, { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { COLORS } from "../constants";
import { useDayFactor } from "../context";

export default function LampPosts() {
  const spots = useMemo(() => {
    const arr = [];
    for (let d = 10; d <= 28; d += 9) {
      arr.push({ x: d, z: 3 });
      arr.push({ x: -d, z: 3 });
      arr.push({ x: 3, z: d });
      arr.push({ x: 3, z: -d });
    }
    return arr;
  }, []);

  const headRef = useRef();
  const dayRef = useDayFactor();
  useFrame((state) => {
    if (!headRef.current) return;
    const t = state.clock.elapsedTime;
    const f = dayRef.current;
    const night = 1 - f;
    headRef.current.children.forEach((c, i) => {
      const m = c.children?.[1]?.material;
      if (m) {
        m.emissiveIntensity = 0.05 + night * (1.35 + Math.sin(t * 2 + i) * 0.15);
      }
      const light = c.children?.[3];
      if (light && light.isLight) {
        light.intensity = night * 1.1;
      }
    });
  });

  return (
    <group ref={headRef}>
      {spots.map((s, i) => (
        <group key={i} position={[s.x, 0, s.z]}>
          <mesh castShadow position={[0, 2.0, 0]}>
            <cylinderGeometry args={[0.1, 0.14, 4, 10]} />
            <meshStandardMaterial color={COLORS.navyDeep} metalness={0.5} roughness={0.55} />
          </mesh>
          <mesh position={[0, 4.15, 0]}>
            <boxGeometry args={[0.55, 0.55, 0.55]} />
            <meshStandardMaterial
              color={COLORS.goldBright}
              emissive={COLORS.gold}
              emissiveIntensity={1.4}
              metalness={0.6}
              roughness={0.3}
            />
          </mesh>
          <mesh position={[0, 4.5, 0]}>
            <coneGeometry args={[0.35, 0.3, 4]} />
            <meshStandardMaterial color={COLORS.navyDeep} metalness={0.5} roughness={0.5} />
          </mesh>
          <pointLight
            position={[0, 4.15, 0]}
            intensity={1.0}
            distance={11}
            decay={2}
            color={COLORS.gold}
            castShadow={false}
          />
        </group>
      ))}
    </group>
  );
}
